import { useForm } from "react-hook-form";
import { postAcGroupAsync } from "src/api/access/ac-group-api";
import { Ac2AccessGroupRequest } from "src/api/access/ac-group-types";
import { useApiOperation } from "src/api/hooks";
import { BaseButton } from "src/components";
import GoToListButton from "src/components/GoToListButton";
import { usePartnerAuthority } from "src/hooks/usePartnerAuthority";
import useNavigate from "src/hooks/usePartnerNavigate";
import { PagePath } from "src/pages/product/details";
import { useModal } from "src/recoil/modalState/hook";
import AcDeviceSection from "./components/AcDeviceSection";
import AcGroupBasicInfoForm from "./components/AcGroupBasicInfoForm";
import AccessGroupSettingForm from "./components/AccessGroupSettingForm";
import EditCancelButton from "src/components/EditCancelButton";

const BasicInfoForm = () => {
  const navigate = useNavigate();
  const { setBaseModal } = useModal();

  const { isAuthority } = usePartnerAuthority();

  const { handleSubmit, control, watch, setValue } = useForm<Ac2AccessGroupRequest>({
    defaultValues: {
      accessGroupName: "",
      memberAccessYn: true, // 이용자 출입 여부
      visitorAccessYn: false, // 방문자 초대 여부
      visitorAccessGroupSelectableYn: false, // Taap 노출 여부
      visitorInvitationApprovalYn: false, // 관리자 승인 여부
      visitorAccessType: "VISITOR_MUTABLE", // QR 발급 타입
      deviceAddIds: [],
    },
  });

  // 출입그룹 생성
  const { executeAsync: postAcGroup } = useApiOperation(postAcGroupAsync);

  const postAcGroupHandler = async (request: Ac2AccessGroupRequest) => {
    try {
      const { data } = await postAcGroup({ accessGroup: request });
      navigate(PagePath.accessGroup.detail.replace(":id", `${data.data.accessGroup.id}`));
    } finally {
      setBaseModal({ isOpen: false });
    }
  };

  const onSubmit = (data: Ac2AccessGroupRequest) => {
    setBaseModal({
      isOpen: true,
      title: "저장하시겠습니까?",
      onClick: () => postAcGroupHandler(data),
      onClose: () => setBaseModal({ isOpen: false }),
      btnRightTitle: "확인",
      btnLeftTitle: "취소",
    });
  };

  const onError = (error: any) => {
    console.log(error);
  };

  return (
    <>
      <form
        onSubmit={(e) => {
          // blur 시점에만 커밋되는 필드(예: 이용 가능 층)가 blur 없이 바로 제출되는 경우를 대비해 강제 커밋
          (document.activeElement as HTMLElement)?.blur();
          handleSubmit(onSubmit, onError)(e);
        }}
      >
        <div className="contents-container__scroll">
          <div className="contents-container__wrap">
            {/* 기본정보 */}
            <AcGroupBasicInfoForm control={control} />
            {/* 설정 */}
            <AccessGroupSettingForm control={control} watch={watch} setValue={setValue} />
            {/* 출입장치 */}
            <AcDeviceSection control={control} watch={watch} setValue={setValue} isAuthority={isAuthority} />
          </div>
        </div>

        {/* 버튼영역 */}
        <div className="contents-container__btn-wrap">
          <div className="left-area"></div>

          <div className="right-area">
            {isAuthority("w") && ( //
              <>
                <EditCancelButton to={PagePath.accessGroup.list} />
                <BaseButton title="저장" className="size-large" type="submit" />
              </>
            )}
          </div>
        </div>
      </form>
    </>
  );
};

export default BasicInfoForm;
